import React, { useState, useEffect } from 'react';

export default function ItemSearchBox({ value, valueName, onSelect, itemMaster, placeholder }) {
  const [query, setQuery] = React.useState('');
  const [results, setResults] = React.useState([]);
  const [open, setOpen] = React.useState(false);

  const search = (q) => {
    setQuery(q);
    if (!q || q.length < 1) { setResults([]); setOpen(false); return; }
    const words = q.toLowerCase().split(/\s+/).filter(Boolean);
    const r = itemMaster.filter(i => {
      const hay = ((i.item_code||'') + ' ' + (i.item_name||'')).toLowerCase();
      return words.every(w => hay.includes(w));
    }).slice(0, 30);
    setResults(r);
    setOpen(true);
  };

  const select = (item) => {
    onSelect(item.item_code);
    setQuery(item.item_code + ' — ' + item.item_name);
    setResults([]);
    setOpen(false);
  };

  React.useEffect(() => {
    if (value && !query) {
      const item = itemMaster.find(i => i.item_code === value);
      if (item) setQuery(item.item_code + ' — ' + item.item_name);
    }
    if (!value) setQuery('');
  }, [value]);

  return (
    <div style={{ position: 'relative' }}>
      <input type="text" placeholder={placeholder || 'Search item by name or code...'}
        value={query} onChange={e => search(e.target.value)}
        onFocus={() => query && results.length > 0 && setOpen(true)}
        style={{ width: '100%' }} />
      {open && results.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid var(--border)', borderRadius: 8, maxHeight: 200, overflowY: 'auto', zIndex: 500, boxShadow: '0 4px 12px rgba(0,0,0,0.12)' }}>
          {results.map(i => (
            <div key={i.id} onClick={() => select(i)}
              style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 12, borderBottom: '1px solid var(--border)' }}
              onMouseEnter={e => e.currentTarget.style.background='var(--bg-hover)'}
              onMouseLeave={e => e.currentTarget.style.background='white'}>
              <span style={{ fontFamily: 'monospace', color: 'var(--accent)' }}>{i.item_code}</span> — {i.item_name}
              <span style={{ float: 'right', color: 'var(--text-muted)', fontSize: 11 }}>{i.unit} · AED {i.unit_cost}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
